var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-vue-page',{attrs:{"showButton":false,"externalParam":_vm.externalParam,"columns":_vm.ListColumn,"list":_vm.detail.list,"total":_vm.detail.total,"selection":false,"tableLoading":_vm.tableLoading},on:{"onSubmit":_vm.getDetailList}})}
var staticRenderFns = []

export { render, staticRenderFns }